module.exports = __webpack_public_path__ + "static/media/curso-ladder-treinamentos-certificado.e475c11d.jpg";